import TimezoneBadgeIcon from '@/assets/icons/TimezoneBadgeIcon';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { getTimezoneOffsetLabel } from 'utils/helperFunctions';

interface TimezoneIndicatorProps {
  timezone?: string | null;
}

export default function TimezoneIndicator({ timezone }: TimezoneIndicatorProps) {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));

  const offsetLabel = useMemo(() => getTimezoneOffsetLabel(timezone), [timezone]);

  if (isMediumScreen || !offsetLabel) return null;

  return (
    <Box
      display='flex'
      alignItems='center'
      gap={0.75}
      px={1.5}
      py={0.75}
      borderRadius='20px'
      bgcolor={theme.palette.primary.light}
      flexShrink={0}
    >
      <Box color={theme.palette.primary.main} display='flex' alignItems='center'>
        <TimezoneBadgeIcon />
      </Box>

      <Typography fontSize={13} fontWeight={500} color={theme.palette.primary.main} whiteSpace='nowrap'>
        Time Zone: {offsetLabel}
      </Typography>
    </Box>
  );
}
